/** Reset the app main column scroll position after route / screen transitions. */
export function scrollMainContentToTop(mainEl?: HTMLElement | null): void {
  const main = mainEl ?? document.querySelector<HTMLElement>('main.main')
  if (!main) return
  main.scrollTo({ top: 0, left: 0 })
  main.scrollTop = 0
  main.scrollLeft = 0
}
